import styles from './header.module.css';
import { UserInfo } from './user-info/user-info';

export const Header = () => {
  return (
    <div className={styles.header}>
      <UserInfo />
    </div>
  );
};
